<template>
  <v-sheet>
    <base-badge
      :imageUrl="badgeUrl"
      class="center-align"
      style="padding-top: 10px;"
    ></base-badge>
    <h1 id="js-course-name" class="center-align course-name">{{ name }}</h1>
    <div id="js-course-description" class="center-align course-description">
      {{ description }}
    </div>
    <learning-items-grid-mentor :courseId="parseInt(courseId)">
    </learning-items-grid-mentor>
  </v-sheet>
</template>

<script>
import EventBus from "@/lib/eventBus"
import LearningItemsGridMentor from "@/containers/learnings/LearningItemsGridMentor"
import BaseBadge from "@/components/BaseBadge"

export default {
  components: {
    BaseBadge,
    LearningItemsGridMentor
  },
  data: function() {
    return {
      courseId: this.$route.params.id,
      panel: []
    }
  },
  computed: {
    name() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.name : ""
    },
    description() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.description : ""
    },
    badgeUrl() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.badge_url : ""
    },
    learningItems() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.learning_items : []
    }
  },
  created() {
    this.$store.dispatch("courses/loadCourse", {
      id: this.courseId,
      showTemplates: false,
      includeHidden: false
    })
    EventBus.$emit("title", undefined)
  },
  methods: {
    completedClass(status) {
      let s = ""
      if (status) {
        s = "completed-item"
      }
      return s
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.completed-item {
  text-decoration: line-through;
}
.course-name {
  color: $orange;
}
.course-description {
  font-style: italic;
  font-size: 1.4em;
  color: $light-grey;
}
.center-align {
  display: flex;
  justify-content: center;
}
</style>
